import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';

import { SincronizacionSapComponent } from './components/sincronizacionsap.component';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { PeriodosmetasService } from '../periodosmetas/services/periodosmetas.service';
import { SincronizacionsapRoutingModule } from './sincronizacionsap-routing.module';

@NgModule({
    declarations: [
        SincronizacionSapComponent
    ],
    imports: [
        CommonModule,
        SincronizacionsapRoutingModule,
        ReactiveFormsModule,
        HttpClientModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatStepperModule,
        MatSnackBarModule,
        MatSelectModule
    ],
    providers: [
        NotificationHelper,
        PeriodosmetasService
    ]
})
export class SincronizacionSapModule { }
